export class ChangePwdModel {

    email: string;
    oldPassword: string;
    newPassword: string;
    newPasswordCheck: string;

}
